var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M3.27344 5.25362H14.0838V5.24805L3.27344 5.25362Z",
    fill: "#FE5F69"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2161 1.39237H11.3595C11.3718 1.32554 11.3784 1.25759 11.3784 1.18741V1.14954C11.3784 0.515734 10.8638 0 10.23 0H7.13562C6.50181 0 5.98608 0.515734 5.98608 1.14954V1.18741C5.98608 1.25759 5.99276 1.32554 6.00501 1.39237H1.14954C0.515733 1.39237 0 1.9081 0 2.54191V4.10471C0 4.73851 0.515733 5.25313 1.14954 5.25313H2.05514V18.7803C2.05514 19.4531 2.60206 20 3.27485 20H14.0908C14.7625 20 15.3105 19.4531 15.3105 18.7803V5.25313H16.2161C16.8499 5.25313 17.3645 4.73851 17.3645 4.10471V2.54191C17.3645 1.9081 16.8499 1.39237 16.2161 1.39237ZM3.28042 18.7803L3.27485 5.25313L14.0852 5.24756V5.25313L14.0908 18.7747L3.28042 18.7803ZM16.1392 4.02785H1.22529V2.61766H16.1392V4.02785Z",
    fill: "#FE5F69"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9831 7.91928V15.9549C5.9831 16.2924 5.70908 16.5676 5.37046 16.5676C5.03183 16.5676 4.75781 16.2924 4.75781 15.9549V7.91928C4.75781 7.58066 5.03183 7.30664 5.37046 7.30664C5.70908 7.30664 5.9831 7.58066 5.9831 7.91928Z",
    fill: "#FE5F69"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2956 7.91928V15.9549C9.2956 16.2924 9.02158 16.5676 8.68296 16.5676C8.34433 16.5676 8.07031 16.2924 8.07031 15.9549V7.91928C8.07031 7.58066 8.34433 7.30664 8.68296 7.30664C9.02158 7.30664 9.2956 7.58066 9.2956 7.91928Z",
    fill: "#FE5F69"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6198 7.99741V16.0331C12.6198 16.3706 12.3447 16.6457 12.0072 16.6457C11.6697 16.6457 11.3945 16.3706 11.3945 16.0331V7.99741C11.3945 7.65878 11.6685 7.38477 12.0072 7.38477C12.3458 7.38477 12.6198 7.65878 12.6198 7.99741Z",
    fill: "#FE5F69"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrash);
export default __webpack_public_path__ + "static/media/icon_trash.72e4dda2.svg";
export { ForwardRef as ReactComponent };